import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
/**
 * Keeps `<html lang="…">` in sync with the active i18n locale.
 * Crawlers (Google, Bing, Baidu) read this attribute to determine
 * the page language — critical for multilingual SEO.
 */
export function useLangSync() {
    const { i18n } = useTranslation();
    useEffect(() => {
        const lang = i18n.language ?? 'pt-BR';
        document.documentElement.lang = lang;
        document.documentElement.dir = 'ltr';
    }, [i18n.language]);
}
